import VesselTrafficCard from './vessel-traffic-card.component'

export default VesselTrafficCard